var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 18.9987V13.9987H14.0006V18.9987C14.0006 19.5487 14.4506 19.9988 15.0006 19.9988H18.0006C18.5506 19.9988 19.0006 19.5487 19.0006 18.9987V11.9987H20.7006C21.1606 11.9987 21.3806 11.4288 21.0306 11.1288L12.6706 3.59875C12.2906 3.25875 11.7106 3.25875 11.3306 3.59875L2.97059 11.1288C2.63059 11.4288 2.84059 11.9987 3.30059 11.9987H5.00059V18.9987C5.00059 19.5487 5.45059 19.9988 6.00059 19.9988H9.00059C9.55059 19.9988 10.0006 19.5487 10.0006 18.9987Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.38f85741721e5ea1a6e334f004506700.svg";
export { ForwardRef as ReactComponent };